<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <OpexFormulario :idTipoOpex="idTipoOpex" :tipoOpex="tipoOpex" :nombreTipoOpex="nombreTipoOpex">
          </OpexFormulario>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OpexCampoFormEditar',
  components: {
    OpexFormulario: () => import('../../components/OpexFormulario')
  },
  data: () => ({
    title: 'EDITAR OPEX CAMPO',
    page: {
      title: 'Editar OPEX Campo'
    },
    breadcrumbs: [
      {
        text: 'Presupuesto',
        disabled: true
      },
      {
        text: 'OPEX Campo',
        disabled: true
      },
      {
        text: 'Editar',
        disabled: false
      }
    ],
    idTipoOpex: 1,
    tipoOpex: 'camp',
    nombreTipoOpex: 'Campo'
  }),
  methods: {
    open() {},
    close() {}
  },
  created() {}
};
</script>
